export interface Movie {
  id: string;
  title: string;
  coverImage: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '热门推荐', slug: 'hot' },
  { name: '动作片', slug: 'action' },
  { name: '喜剧片', slug: 'comedy' },
  { name: '爱情片', slug: 'romance' },
  { name: '科幻片', slug: 'scifi' },
  { name: '恐怖片', slug: 'horror' },
  { name: '剧情片', slug: 'drama' },
  { name: '动画片', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
  { name: '电视剧', slug: 'tv-series' },
  { name: '综艺', slug: 'variety' },
];

export const heroMovies = [
  {
    id: 'hero-1',
    title: '流浪地球3',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20spaceship%20flying%20through%20nebula%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20golden%20tones%2C%20cinematic%20composition%2C%20movie%20poster%20quality%2C%20grand%20scale%2C%20atmospheric%20glow&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
    year: 2026,
    category: '科幻片',
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。第三部讲述人类抵达新星系后面临的全新挑战。',
    tags: ['科幻', '灾难', '冒险'],
  },
  {
    id: 'hero-2',
    title: '长安十二时辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20twilight%2C%20lantern-lit%20streets%20of%20Changan%2C%20warm%20golden%20and%20red%20color%20palette%2C%20cinematic%20atmosphere%2C%20epic%20historical%20drama%20aesthetic%2C%20grand%20palace%20architecture%20silhouette&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
    year: 2025,
    category: '电视剧',
    rating: 9.5,
    description: '唐朝天宝年间，长安城陷入一场惊天阴谋。死囚张小敬临危受命，必须在十二时辰内拯救这座万国之都。',
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: 'hero-3',
    title: '哪吒之魔童闹海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20scene%20with%20fire%20and%20water%20elements%20clashing%2C%20dramatic%20red%20and%20blue%20color%20contrast%2C%20epic%20fantasy%20battle%20atmosphere%2C%20cinematic%20lighting%2C%20dynamic%20composition%2C%20grand%20scale%20mythological%20scene&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
    year: 2025,
    category: '动画片',
    rating: 9.0,
    description: '哪吒与敖丙在天劫之后灵魂幸存，太乙真人用莲藕重塑肉身。面对东海龙族的复仇，哪吒必须做出选择。',
    tags: ['动画', '神话', '奇幻'],
  },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    coverImage: 'https://readdy.ai/api/search-image?query=Movie%20poster%20style%2C%20massive%20spaceship%20near%20ringed%20planet%2C%20warm%20orange%20glow%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20clean%20background%20with%20stars%2C%20dramatic%20composition&width=400&height=560&seq=movie-card-01&orientation=portrait',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。',
    tags: ['科幻', '灾难', '冒险'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-28 更新',
  },
  {
    id: 'movie-2',
    title: '满江红2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Chinese%20soldier%20in%20armor%20with%20determined%20expression%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20portrait%2C%20dramatic%20lighting%2C%20clean%20dark%20background&width=400&height=560&seq=movie-card-02&orientation=portrait',
    year: 2025,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.8,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案牵出惊天阴谋。',
    tags: ['历史', '悬疑', '剧情'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-25 更新',
  },
  {
    id: 'movie-3',
    title: '哪吒之魔童闹海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20style%2C%20mythological%20warrior%20boy%20with%20fire%20powers%2C%20flaming%20red%20and%20orange%20colors%2C%20dynamic%20pose%2C%20epic%20fantasy%20atmosphere%2C%20clean%20dark%20background&width=400&height=560&seq=movie-card-03&orientation=portrait',
    year: 2025,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.0,
    description: '哪吒与敖丙在天劫之后灵魂幸存，太乙真人用莲藕重塑肉身。',
    tags: ['动画', '神话', '奇幻'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-22 更新',
  },
  {
    id: 'movie-4',
    title: '长安十二时辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20TV%20drama%20poster%2C%20Tang%20dynasty%20official%20in%20traditional%20costume%2C%20lantern-lit%20ancient%20street%20background%2C%20warm%20golden%20tones%2C%20cinematic%20portrait%20style%2C%20mysterious%20atmosphere&width=400&height=560&seq=movie-card-04&orientation=portrait',
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 9.5,
    description: '唐朝天宝年间，长安城陷入一场惊天阴谋，死囚张小敬临危受命拯救都城。',
    tags: ['古装', '悬疑', '历史'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-20 更新至48集',
  },
  {
    id: 'movie-5',
    title: '封神第二部',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20warrior%20with%20magical%20weapon%2C%20epic%20battle%20scene%20silhouette%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20quality%2C%20dramatic%20lighting&width=400&height=560&seq=movie-card-05&orientation=portrait',
    year: 2025,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.7,
    description: '姜子牙率众神将讨伐商纣王，一场天地变色的大战即将展开。',
    tags: ['神话', '动作', '奇幻'],
    isHot: true,
    isNew: true,
    updateInfo: '2026-07-27 更新',
  },
  {
    id: 'movie-6',
    title: '独行月球2',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20movie%20poster%2C%20astronaut%20standing%20alone%20on%20lunar%20surface%2C%20Earth%20in%20background%2C%20warm%20silver%20and%20blue%20tones%2C%20cinematic%20quality%2C%20humorous%20pose%2C%20clean%20space%20background&width=400&height=560&seq=movie-card-06&orientation=portrait',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.5,
    description: '月球基地上最后一个人类，开启了一段啼笑皆非的太空生存之旅。',
    tags: ['喜剧', '科幻', '冒险'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-07-29 更新',
  },
  {
    id: 'movie-7',
    title: '孤注一掷2',
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20dark%20urban%20alley%20scene%2C%20mysterious%20figure%20in%20shadow%2C%20tense%20atmosphere%2C%20warm%20amber%20streetlight%20tones%2C%20cinematic%20noir%20style%2C%20gritty%20texture&width=400&height=560&seq=movie-card-07&orientation=portrait',
    year: 2025,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.9,
    description: '程序员潘生和模特安娜被高薪招聘吸引出国，却卷入一场精心设计的网络诈骗陷阱。',
    tags: ['犯罪', '剧情', '现实'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-18 更新',
  },
  {
    id: 'movie-8',
    title: '异人之下2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20movie%20poster%2C%20modern%20martial%20artist%20with%20energy%20powers%2C%20dynamic%20combat%20pose%2C%20neon%20and%20warm%20tones%2C%20urban%20fantasy%20style%2C%20cinematic%20quality&width=400&height=560&seq=movie-card-08&orientation=portrait',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.3,
    description: '拥有特异功能的异人们隐藏在都市之中，一场异能大战一触即发。',
    tags: ['动作', '奇幻', '都市'],
    isHot: false,
    isNew: true,
    updateInfo: '2026-07-26 更新',
  },
  {
    id: 'movie-9',
    title: '白蛇·浮生',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20elegant%20woman%20in%20white%20traditional%20dress%2C%20flowing%20silk%20ribbons%2C%20water%20and%20lotus%20elements%2C%20soft%20ethereal%20lighting%2C%20romantic%20atmosphere%2C%20dreamy%20composition&width=400&height=560&seq=movie-card-09&orientation=portrait',
    year: 2025,
    category: '动画片',
    categorySlug: 'animation',
    rating: 8.6,
    description: '白蛇修炼千年化为人形，与书生许仙在西湖断桥相遇，一段跨越种族的人妖之恋。',
    tags: ['动画', '爱情', '神话'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-15 更新',
  },
  {
    id: 'movie-10',
    title: '三大队',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20police%20crime%20drama%20movie%20poster%2C%20three%20detectives%20in%20uniform%2C%20serious%20expressions%2C%20urban%20night%20scene%20background%2C%20warm%20streetlight%20tones%2C%20cinematic%20style%2C%20tense%20atmosphere&width=400&height=560&seq=movie-card-10&orientation=portrait',
    year: 2024,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 9.1,
    description: '刑警队长程兵带领三大队追踪一起重大案件，十二年追凶从未放弃。',
    tags: ['犯罪', '剧情', '真实'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-10 更新',
  },
  {
    id: 'movie-11',
    title: '庆余年第二季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%2C%20young%20scholar%20in%20traditional%20costume%2C%20ancient%20palace%20background%2C%20warm%20golden%20tones%2C%20cinematic%20portrait%2C%20elegant%20atmosphere&width=400&height=560&seq=movie-card-11&orientation=portrait',
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 9.3,
    description: '范闲率领使团回归途中遭遇刺杀，朝堂之上的权力斗争愈演愈烈。',
    tags: ['古装', '权谋', '小说改编'],
    isHot: true,
    isNew: false,
    updateInfo: '2026-07-19 更新至36集',
  },
  {
    id: 'movie-12',
    title: '熊出没·重启未来',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%2C%20two%20bears%20in%20futuristic%20setting%2C%20colorful%20and%20playful%20atmosphere%2C%20warm%20and%20bright%20colors%2C%20family-friendly%20style%2C%20clean%20composition&width=400&height=560&seq=movie-card-12&orientation=portrait',
    year: 2025,
    category: '动画片',
    categorySlug: 'animation',
    rating: 7.9,
    description: '光头强和熊大熊二意外进入未来世界，开启了一段奇妙的科幻冒险。',
    tags: ['动画', '家庭', '科幻'],
    isHot: false,
    isNew: false,
    updateInfo: '2026-07-05 更新',
  },
];

export const hotRanking: Movie[] = [
  movies[0], movies[1], movies[2], movies[4], movies[6],
  movies[3], movies[10], movies[7], movies[8], movies[5],
];

export const latestUpdates: Movie[] = [
  movies[5], movies[0], movies[7], movies[3], movies[8],
  movies[1], movies[10], movies[6],
];